import { render, staticRenderFns } from "./project_list_item_inactive_badge.vue?vue&type=template&id=3ef1c05f"
import script from "./project_list_item_inactive_badge.vue?vue&type=script&lang=js"
export * from "./project_list_item_inactive_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports